var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import "../KeyboardFunctions.css";
import { DefaultComposableKeyLabel, FunctionKeyAttributeName, FunctionKeyId, PostDefaultFunctionKeys, PreDefaultFunctionKeys, } from "../constants";
import { KeyButton } from "./KeyButton";
import { Separator } from "./Separator";
import SpaceBetween from "@cloudscape-design/components/space-between";
import Header from "@cloudscape-design/components/header";
/**
 * Allow users to use the function keys and execute actions by clicking additional buttons.
 *
 * In order to effectively use the keyboard functions component, carefully consider memoizing
 * the component and `onClickKey` event function to avoid unnecessary re-renders.
 * <pre>
 *   const MemoizedKeyboardFunctions = React.memo(KeyboardFunctions);
 *   const memoizedOnClickKey = React.useCallback(onClickKey, [...]);
 *   ...
 *   <MemoizedKeyboardFunctions
 *     ...
 *     onClickKey={memoizedOnClickKey}
 *   />
 * </pre>
 */
export var KeyboardFunctions = function (props) {
    var _a = useState(false), ctrlKeySelected = _a[0], setCtrlKeySelected = _a[1];
    var _b = useState(false), altKeySelected = _b[0], setAltKeySelected = _b[1];
    var _c = useState(false), shiftKeySelected = _c[0], setShiftKeySelected = _c[1];
    return (_jsxs(SpaceBetween, __assign({ size: "s" }, { children: [_jsx(Header, __assign({ variant: "h2", description: props.description }, { children: props.header })), _jsxs(SpaceBetween, __assign({ direction: "horizontal", size: "s" }, { children: [_jsx(KeyButton, { selected: ctrlKeySelected, label: DefaultComposableKeyLabel[FunctionKeyAttributeName.controlKey], ariaLabel: props.i18nAriaLabels.controlKey, onClick: function () {
                            props.onClickKey({
                                keyId: FunctionKeyId.controlKey,
                                ctrlKey: !ctrlKeySelected,
                                altKey: altKeySelected,
                                shiftKey: shiftKeySelected,
                            });
                            setCtrlKeySelected(!ctrlKeySelected);
                        } }), _jsx(KeyButton, { selected: altKeySelected, label: DefaultComposableKeyLabel[FunctionKeyAttributeName.altKey], ariaLabel: props.i18nAriaLabels.altKey, onClick: function () {
                            props.onClickKey({
                                keyId: FunctionKeyId.altKey,
                                ctrlKey: ctrlKeySelected,
                                altKey: !altKeySelected,
                                shiftKey: shiftKeySelected,
                            });
                            setAltKeySelected(!altKeySelected);
                        } }), _jsx(KeyButton, { selected: shiftKeySelected, label: DefaultComposableKeyLabel[FunctionKeyAttributeName.shiftKey], ariaLabel: props.i18nAriaLabels.shiftKey, onClick: function () {
                            props.onClickKey({
                                keyId: FunctionKeyId.shiftKey,
                                ctrlKey: ctrlKeySelected,
                                altKey: altKeySelected,
                                shiftKey: !shiftKeySelected,
                            });
                            setShiftKeySelected(!shiftKeySelected);
                        } }), _jsx(Separator, {}), __spreadArray(__spreadArray(__spreadArray([], PreDefaultFunctionKeys.map(function (key) { return (__assign(__assign({}, key), { ariaLabel: props.i18nAriaLabels[key.name] })); }), true), (props.additionalKeys || []), true), PostDefaultFunctionKeys.map(function (key) { return (__assign(__assign({}, key), { ariaLabel: props.i18nAriaLabels[key.name] })); }), true).map(function (_a) {
                        var label = _a.label, ariaLabel = _a.ariaLabel, id = _a.id;
                        return (_jsx(KeyButton, { label: label, ariaLabel: ariaLabel, onClick: function () {
                                props.onClickKey({
                                    keyId: id,
                                    ctrlKey: ctrlKeySelected,
                                    altKey: altKeySelected,
                                    shiftKey: shiftKeySelected,
                                });
                            } }, id));
                    }), props.additionalButtons] }))] })));
};
